import React from "react";
import ScanLimits from "./scanLimits";
import LocationAccess from "./locationAccess";
import Password from "./password";
import ScheduleAccess from "./scheduleAccess";
import ExpirationDate from "./expirationDateSetting";
import {
  addDayItem,
  applyAll,
  removeDayItem,
  resetDayField,
  setDayField,
  setScheduleDateEnd,
  setScheduleDateStart,
  setScheduleTimezone,
  setToggleActiveDay,
} from "../../redux/slices/settings";

const Restriction = () => {
  return (
    <>
      <ScanLimits />
      <LocationAccess />
      <ScheduleAccess
        setScheduleTimezone={setScheduleTimezone}
        setScheduleDateStart={setScheduleDateStart}
        setScheduleDateEnd={setScheduleDateEnd}
        addDayItem={addDayItem}
        applyAll={applyAll}
        removeDayItem={removeDayItem}
        resetDayField={resetDayField}
        setDayField={setDayField}
        setToggleActiveDay={setToggleActiveDay}
      />
      <Password />
      <ExpirationDate/>
    </>
  );
};

export default Restriction;
